<template>
  <div>
    <custom-dialog width="1200px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <div class="item-title">{{ $t('dms_groupDeviceDialog.she_bei_xin_xi') }}</div>
        <custom-table :data="tableList" :index="true" tableCode="groupDevice" @filter="filterChange" @sort="sortChange"></custom-table>
        <div class="item-title" style="margin-top: 20px">
          {{ $t('dms_groupDeviceDialog.qu_yu_xin_xi') }}
        </div>
        <div class="item-tip">
          <i class="icon icon-tishi"></i>
          <span>{{ $t('dms_groupDeviceDialog.sbljdtjqhcxzqydljdt') }}</span>
        </div>
        <el-form :model="form" ref="form" size="mini" label-width="auto" :rules="rules">
          <el-form-item :label="$t('dms_groupDeviceDialog.qu_yu')" prop="siteId">
            <custom-select
              :listener="listener"
              style="display: inline-block; vertical-align: top"
              :filterable="true"
              v-model="form.siteId"
              url="locationSiteList"
              :params="{ locationId: model.row.locationId }"
              :props="{ label: 'siteName', value: 'siteId' }"
              @change="change"
              width="280px"
              @getList="getList"
            ></custom-select>
            <el-button size="small" style="margin-left: 8px" type="primary" @click="addWebSite()">
              <i class="icon icon-add"></i>
              {{ $t('dms_groupDeviceDialog.xin_zeng_qu_yu') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
    <project-site-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onChangeSite()"></project-site-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import projectSiteDialog from '@/pages/dms/components/project_site_dialog.vue';

export default {
  mixins: [dialogMixins],
  components: { projectSiteDialog },
  data() {
    return {
      selectRow: {},
      listener: '0',
      form: {
        bodyNum: '',
        siteCode: '',
        siteId: '',
      },
      tableList: [],
      groupList: [],
      dialogModel: {},
      dialogVisible: false,
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        siteId: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          { max: 30, message: this.$t('Common.com_rules_length_max', [30]) },
        ],
      };
    },
  },
  methods: {
    getList: function (list) {
      this.groupList = list;
    },
    change: function (item) {
      if (item && this.form.siteId !== item.siteCode) {
        this.form.siteCode = item.siteCode;
      } else {
        this.form.siteCode = '';
      }
    },
    // 新增
    addWebSite: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.data = this.selectRow;
      this.dialogModel.title = this.$t('dms_groupDeviceDialog.xin_zeng_qu_yu');
      this.dialogVisible = true;
    },
    onChangeSite: function () {
      this.listener = `${Number.parseInt(this.listener, 10) + 1}`;
    },
    // 初始化
    initDialog: function () {
      this.selectRow = this.model.row;
      this.tableList = [this.model.row];
      this.form.bodyNum = this.model.row.bodyNum;
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(apis.stockGroupUpdate, this.form, true).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
          this.visible = false;
        });
      });
    },
  },
};
</script>

<style lang="scss"></style>
